import { useSelector } from 'react-redux';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './dndCard.module.scss';
import { ExpandButton, HideButton } from './buttons';
import { DndCardProvider } from './context';

export default function DndCard({
  id,
  children,
  toggleHide,
  toggleExpand,
  className = '',
  style: styleProp,
  type = 'card',
  withHide = true,
  withExpand = true,
  expanded = false,
  visible = false,
  __css = {},
  ...rest
}) {
  const { edition } = useSelector((state) => state.DashboardSlice);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: !edition.active || !visible });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    ...__css,
  };
  const classNames = `${styles.dndCardWrapper} ${
    edition.active ? styles.dndCardWrapperActive : ''
  } ${!visible ? styles.dndCardWrapperHide : ''} ${className}`;

  return (
    <Box
      ref={setNodeRef}
      style={style}
      className={classNames}
      data-expanded={expanded}
      data-type={type}
      {...attributes}
      {...listeners}
      {...rest}
    >
      <Box
        className={styles.controlsWrapper}
        onMouseDownCapture={(event) => event.stopPropagation()}
        onPointerDownCapture={(event) => event.stopPropagation()}
      >
        {withHide && <HideButton visible={visible} toggleHide={toggleHide} />}
        {withExpand && visible && (
          <ExpandButton expanded={expanded} toggleExpand={toggleExpand} />
        )}
      </Box>

      <DndCardProvider value={{ visible }}>
        <Box className={styles.childrenWrapper}>{children}</Box>
      </DndCardProvider>
    </Box>
  );
}
